module.exports = __webpack_public_path__ + "static/media/1_en.bc17785c.png";